import './Footer.css';
import React, { useRef, useEffect, useState } from "react";
import emailjs from '@emailjs/browser';
import igLogo from '../assets/Footer/igLogo.png';
import fbLogo from '../assets/Footer/fbLogo.png';

function Footer({ productoNombre }) {
    const form = useRef();
    const mensajeRef = useRef(); // ⬅️ Referencia para el textarea
    const [formData, setFormData] = useState({
        user_name: '',
        user_email: '',
        user_phone: '',
        message: ''
    });
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        if (productoNombre && mensajeRef.current) {
            const mensajeDefault =
                `Solicito ficha técnica y MSDS del producto ${productoNombre}.
` +
                `Empresa: 
` +
                `CUIT: 
` +
                `Aplicación del producto: `;
            mensajeRef.current.value = mensajeDefault;
            setFormData((prev) => ({ ...prev, message: mensajeDefault }));
        }
    }, [productoNombre]);

    useEffect(() => {
        // Validar que todos los campos requeridos estén completos
        setIsValid(
            formData.user_name.trim() !== '' &&
            formData.user_email.trim() !== '' &&
            formData.user_phone.trim().length > 0 &&
            formData.user_phone.trim().length <= 15 &&
            formData.message.trim() !== ''
        );
    }, [formData]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        let newValue = value;
        if (name === 'user_phone') {
            // Solo permitir números y máximo 15 dígitos
            newValue = newValue.replace(/[^0-9]/g, '').slice(0, 15);
        }
        setFormData({ ...formData, [name]: newValue });
        if (name === 'message' && mensajeRef.current) {
            mensajeRef.current.value = newValue;
        }
    };

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm(
            'service_ef7hiza',
            'template_oi31vz9',
            form.current,
            'pzEA2Wvf8a5yTdT9Q'
        )
            .then((result) => {
                console.log(result.text);
                alert("Mensaje enviado correctamente");
                form.current.reset();
                setFormData({ user_name: '', user_email: '', user_phone: '', message: '' });
            }, (error) => {
                console.log(error.text);
                alert("Error al enviar el mensaje");
            });
    };

    return (
        <footer className="footer-container" id="footer">
            <div className="footer-top">
                <div className="footer-left">
                    <div className="footer-info">
                        {/* <p><strong>Dirección:</strong></p>
                        <p>Av. Siempre Viva 123, Buenos Aires</p> */}
                        <p><strong>Teléfono:</strong></p>
                        <p>+5491151489606</p>
                        <p><strong>Email:</strong></p>
                        <p>info@silandeargentina.com</p>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5rem' }}>
                            <a href="https://www.instagram.com/silandeargentina/?igsh=MWFjM2lwYmZ1dnIzZg%3D%3D#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <img src={igLogo} alt="Instagram" style={{ width: 32, height: 32, marginRight: 16 }} />
                            </a>
                            <a href="https://www.facebook.com/people/Silande-Arg/pfbid02ZCkrPnKqQ41ah9mc16Rf1QEq9vSWCjpr9yDjpAuSHde1CMajKA5Q35mWB5hKEqK2l/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <img src={fbLogo} alt="Facebook" style={{ width: 32, height: 32 }} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-right">
                    <h3 style={{ marginBottom: "2rem" }}>Haga su consulta</h3>
                    <form className="footer-form" ref={form} onSubmit={sendEmail}>
                        <div className="footer-form-row">
                            <input
                                type="text"
                                name="user_name"
                                placeholder="Nombre"
                                required
                                value={formData.user_name}
                                onChange={handleChange}
                            />
                            <input
                                type="email"
                                name="user_email"
                                placeholder="Email"
                                required
                                value={formData.user_email}
                                onChange={handleChange}
                            />
                        </div>
                        <input
                            type="number"
                            name="user_phone"
                            placeholder="Teléfono"
                            required
                            value={formData.user_phone}
                            onChange={handleChange}
                            maxLength={15}
                        />
                        <textarea
                            name="message"
                            placeholder="Asunto"
                            rows="8"
                            required
                            ref={mensajeRef}
                            value={formData.message}
                            onChange={handleChange}
                        />
                        <button type="submit" disabled={!isValid} style={!isValid ? { opacity: 0.5, cursor: 'not-allowed' } : {}}>Enviar</button>
                    </form>
                </div>
            </div>

            <div className="footer-bottom">
                <h6 className='title'>© Powered by <a href="https://www.agarucorp.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>AgaruCorp</a> | 2025 Silande Argentina</h6>
            </div>
        </footer>
    );
}

export default Footer;
